import "./LoginMobileView.scss";

const LoginMobileView = ({
    logo_svg,
    email,
    password,
    errorMsg,
    onEmailChange,
    onPasswordChange,
    onSubmit,
    showSaveCredentialsPopup = false,
    onSaveCredentials,
    onDismissCredentials,
}) => {
    return (
        <>

            <div className='login-mobile-view'>
                <div className='mobile-view-dynamic-island'>
                </div>
                <div className='login-mobile-view-container'>
                    <div className='login-mobile-view-container-logo'>
                        <img className='login-logo' src={logo_svg} alt="logo" />
                        <div className='login-mobile-view-container-logo-title'>noccarc</div>
                    </div>
                    <div className='login-mobile-view-container-inputs'>
                        <div className='login-mobile-view-container-inputs-title'>Sign In</div>
                        <div className='login-mobile-view-container-inputs-container'>
                            {/* <div className='email-container'> */}
                            <input
                                className='login-input email'
                                type='email'
                                placeholder='Email ID'
                                value={email || ""}
                                onChange={onEmailChange}
                            />
                            {/* </div> */}

                            {/* <div className='password-container'> */}
                            <input
                                className='login-input password'
                                type="password"
                                placeholder='Password'
                                value={password || ""}
                                onChange={onPasswordChange}
                            />
                            {/* </div> */}

                            <div className='error-msg'>
                                {errorMsg}
                            </div>
                        </div>



                    </div>
                    <div className='login-mobile-view-container-sign-in'>
                            <button
                                className='sign-in sign-in-botton'
                                onClick={onSubmit}
                            >
                                Sign In
                            </button>
                    </div>
                </div>

            </div>

            {showSaveCredentialsPopup && (
                <div className="login-save-credentials" role="dialog" aria-modal="true">
                    <div className="login-save-credentials__backdrop" />
                    <div className="login-save-credentials__card">
                        <p className="login-save-credentials__message">
                            Do you want to save credentials for auto-fast signIn?
                        </p>
                        <div className="login-save-credentials__actions">
                            <button
                                type="button"
                                className="login-save-credentials__btn login-save-credentials__btn--dismiss"
                                onClick={onDismissCredentials}
                            >
                                Dismiss
                            </button>
                            <button
                                type="button"
                                className="login-save-credentials__btn login-save-credentials__btn--yes"
                                onClick={onSaveCredentials}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default LoginMobileView;


